import React, { useEffect, useRef, useState } from "react";
import { FiShoppingCart } from "react-icons/fi";
import { FaRegHeart, FaHeart } from "react-icons/fa";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { MdFilterList, MdArrowDropDown } from "react-icons/md";
import { CustomeStyle } from "../Css/CustomeStyle";
import Footer from "../Fotter";
import Header from "../pages/header";
import { useDispatch, useSelector } from "react-redux";
import { fetchProducts } from "../redux/slices/AllProductSlice";
import { AddToCart } from "../redux/slices/AddTocartSlice";
import { toast } from "react-toastify";
import {
  clearFilterProductData,
  FilterProduct,
} from "../redux/slices/FilterProductSlice";
import {
  clearPriceFilterData,
  PriceFilter,
} from "../redux/slices/PriceFilterSlice";
import ReactPaginate from "react-paginate";
import appdownload from "../assets/appdownload2.png";

function AllProductData() {
  const navigate = useNavigate()
  const location = useLocation();
  const sidebarRef = useRef(null);
  const [isSidebarVisible, setIsSidebarVisible] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedBrand, setSelectedBrand] = useState([]);
  const [likedProducts, setLikedProducts] = useState(new Set());
  const [isSidebarVisible1, setIsSidebarVisible1] = useState(false);
  const [selectedOption, setSelectedOption] = useState("Default Sorting");
  const dispatch = useDispatch();
  const { AllData } = useSelector((state) => state?.product);
  const [selectedRanges, setSelectedRanges] = useState([]);
  const [isVisible, setIsVisible] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [ordersPerPage] = useState(100);


  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  useEffect(() => {
    if (location.state?.page !== undefined) {
      setCurrentPage(location.state.page);
    }
  }, [location.state]);

  useEffect(() => {
    dispatch(fetchProducts());
  }, [dispatch]);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    setSelectedBrand("");
    if (selectedCategory) {
      dispatch(clearPriceFilterData());
      setSelectedRanges([]);
      dispatch(FilterProduct({ name: "category", Catename: selectedCategory }));
    }
  }, [dispatch, selectedCategory]);

  useEffect(() => {
    if (selectedCategory && selectedRanges?.length > 0) {
      dispatch(clearPriceFilterData());
      dispatch(
        PriceFilter({
          name: "category",
          price: "priceRange",
          priceRanges: selectedRanges,
          Catename: selectedCategory,
        })
      );
    }
    if (selectedBrand && selectedRanges?.length > 0) {
      dispatch(clearPriceFilterData());
      PriceFilter({
        name: "brand",
        price: "priceRange",
        priceRanges: selectedRanges,
        Catename: selectedBrand,
      });
    }
  }, [selectedRanges, dispatch, selectedCategory, selectedBrand]);

  const options = [
    "Default Sorting",
    "Sort by price: low to high",
    "Sort by price: high to low",
    "Sort by latest",
  ];

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    setIsSidebarVisible1(false);
  };

  const toggleLike = (productId) => {
    setLikedProducts((prevLikedProducts) => {
      const updatedLikes = new Set(prevLikedProducts);
      if (updatedLikes.has(productId)) {
        updatedLikes.delete(productId);
      } else {
        updatedLikes.add(productId);
      }
      return updatedLikes;
    });
  };

  const handleAddToCart = (item) => {
    console.log("Adding to cart:", item); // 👈 Console before dispatch
    const cartData = {
      productId: item?._id,
      quantity: 1,
    };
    dispatch(AddToCart(cartData)).then((result) => {
      if (result.meta.requestStatus === "fulfilled") {
        console.log("Added to cart successfully:", result); // 👈 Console on success
        toast.success("Product added to cart!", {
          position: "top-right",
          autoClose: 2000,
          style: {
            backgroundColor: "#d0d3d4 ",
            color: "black",
            fontWeight: "bold",
          },
        });
      } else {
        console.log("Responce Error");
      }
    });
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsSidebarVisible1(false);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
      setIsSidebarVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handlePageClick = (event) => {
    navigate(location.pathname, { replace: true });
    setCurrentPage(event.selected);
  };

  const generateSlug = (text) => {
    if (!text) {
      return "";
    }
    return text
      .toLowerCase()
      .replace(/[^\w\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");
  };

  useEffect(() => {
    const script1 = document.createElement("script");
    script1.src = "https://www.googletagmanager.com/gtag/js?id=AW-16647750621";
    script1.async = true;
    document.head.appendChild(script1);

    script1.onload = () => {
      const script2 = document.createElement("script");
      script2.innerHTML = `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'AW-16647750621');
        `;
      document.head.appendChild(script2);
    };

    return () => {
      const scripts = document.querySelectorAll(
        'script[src="https://www.googletagmanager.com/gtag/js?id=AW-16647750621"]'
      );
      scripts.forEach((script) => script.remove());
    };
  }, []);

  const offset = currentPage * ordersPerPage;
  const productData = AllData?.data?.slice(offset, offset + ordersPerPage);
  const pageCount = Math.ceil(AllData?.data?.length / ordersPerPage);

  return (
    <div className="min-h-screen bg-gray-50 ">
      <Header />
      <div className="w-[70%] mx-auto mb-10 bg-gradient-to-r from-blue-100 via-sky-200 to-blue-100 rounded-xl p-8 flex flex-col md:flex-row justify-between items-center gap-8">
        {/* Left Content */}
        <div className="text-center md:text-left max-w-xl">
          <h2 className="text-4xl font-semibold text-gray-800 mb-4 leading-tight">
            Unlock Amazing Deals with Our App!
          </h2>
          <p className="text-gray-700 mb-6 text-lg opacity-90">
            Enjoy exclusive discounts, faster checkout, real-time order
            tracking, and priority support. Download the app now and save more!
          </p>

          {/* Features List */}

          {/* App Store Buttons */}
          <div className="flex gap-6 justify-center mt-6">
            <a
              href="https://play.google.com/store/apps/details?id=com.bharatcod&hl=en"
              className="bg-blue-400 text-black px-6 py-3 rounded-lg flex items-center gap-3 hover:bg-orange-600 transition-all duration-300"
            >
              <span className="text-xl">Download App</span>
            </a>
          </div>
        </div>

        {/* Right Side Image Placeholder */}
        <div className="hidden md:block w-[27%] h-[230px] flex items-center justify-center">
          <img
            src={appdownload}
            alt="Exclusive Offers"
            className="w-full h-full object-contain"
          />
        </div>
      </div>
      <div className="mx-[5%] md:hidden z-50 mt-[3%] bg-gray-200 flex flex-row justify-between px-2 items-center rounded">
        <button
          className="px-4 py-2  flex flex-row gap-1"
          onClick={() => {
            setIsSidebarVisible(!isSidebarVisible);
            setIsSidebarVisible1(false);
          }}
        >
          <MdFilterList size={24} className="text-gray-700" />
          <div className="text-gray-700 font-bold">Filter</div>
        </button>
        <div className="relative inline-block text-left ">
          <button
            className="px-4 py-2 m-2 flex flex-row bg-white rounded-2xl border border-gray-300 shadow-sm"
            onClick={() => setIsSidebarVisible1(!isSidebarVisible1)}
          >
            <div className="text-gray-700 font-bold truncate">
              {selectedOption}
            </div>
            <MdArrowDropDown className="text-gray-500 ml-2" size={24} />
          </button>

          {isSidebarVisible1 && (
            <div className="z-10 absolute mt-2 bg-white rounded-lg shadow-lg border border-gray-200 w-60">
              {options.map((option, index) => (
                <div
                  key={index}
                  onClick={() => handleOptionClick(option)}
                  className="px-4 py-2 text-black hover:bg-gray-100 cursor-pointer"
                >
                  {option}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <div className="w-[90%] mx-auto flex flex-col md:flex-row gap-8 justify-center mb-[3%]">
        <div className="w-full sm:w-[95%] md:w-[100%] mt-0 md:mt-8 ">
          <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 sm:gap-1 lg:gap-3 ">
            {productData?.length > 0 ? (
              productData?.map((item) => (
                <div
                  key={item?._id}
                  className="bg-white shadow rounded-md overflow-hidden relative border border-gray-200 
                    sm:px-4 sm:py-2 px-3 py-2 hover:scale-105 hover:-translate-y-1"
                >
                  <img
                    src={item?.images[0]}
                    alt={item?.images?.itemimage1}
                    className="w-full h-28 object-contain rounded-x"
                  />
                  <button
                    className="like-btn absolute top-2 left-2"
                    onClick={() => toggleLike(item._id)}
                  >
                    {likedProducts.has(item._id) ? (
                      <FaHeart
                        size="24px"
                        className="text-red-500 sm:text-lg text-xs"
                      />
                    ) : (
                      <FaRegHeart
                        size="24px"
                        className="text-gray-400 sm:text-lg md:text-xs"
                      />
                    )}
                  </button>
                  <button
                    onClick={() => handleAddToCart(item)}
                    className="like-btn absolute top-2 right-2 px-2 py-2 bg-gray-100 text-white rounded-lg hover:bg-green-50"
                  >
                    <FiShoppingCart className="text-gray-700 sm:text-base md:text-xl lg:text-2xl" />
                  </button>

                  <Link
                    to={`/category/${item?.category ? generateSlug(item?.category) : "-"
                      }/${generateSlug(item?.title)}/${generateSlug(item?._id)}`}
                    state={{
                      item,
                      page: currentPage,
                    }}
                    className="block  no-underline"
                  >
                    <div className="end-2 lg:mt-3">
                      <h2 className="text-black text-sm md:text-base line-clamp-1 font-bold leading-none mb-1">
                        {item.title}
                      </h2>
                      <div>
                        <span className={CustomeStyle.description}>
                          {item.description}
                        </span>
                      </div>
                      <div className="flex items-center justify-center gap-2">
                        <span className={CustomeStyle.text}>
                          ₹{item?.salePrice}
                        </span>
                        <span className="line-through text-gray-500 text-sm">
                          ₹{item?.regularPrice}
                        </span>
                      </div>
                    </div>
                  </Link>
                </div>
              ))
            ) : (
              <div className="flex items-center justify-center w-full text-red-500 font-semibold text-lg mt-5">
                No Products Found
              </div>
            )}
          </div>
        </div>
      </div>
      <button
        onClick={scrollToTop}
        className={`fixed bottom-5 right-5 border bg-gray-200 text-black font-semibold px-4 py-2 rounded-full shadow-lg transition-all duration-300 ${isVisible ? "opacity-100 scale-100" : "opacity-0 scale-0"
          }`}
      >
        ⬆ Top
      </button>
      <div className="w-full flex justify-center mt-6 mb-5">
        <div className="w-full max-w-[90%] sm:max-w-[70%] md:max-w-[60%] lg:max-w-[50%] overflow-auto">
          <ReactPaginate
            previousLabel={
              <span className="px-1 py-1 text-xs sm:text-sm font-medium whitespace-nowrap">
                Prev
              </span>
            }
            nextLabel={
              <span className="px-1 py-1 text-xs sm:text-sm font-medium whitespace-nowrap">
                Next
              </span>
            }
            breakLabel={"..."}
            pageCount={pageCount}
            marginPagesDisplayed={1}
            pageRangeDisplayed={window.innerWidth > 768 ? 5 : 3}
            onPageChange={handlePageClick}
            containerClassName="flex items-center justify-center gap-2 px-2 py-2 overflow-auto no-scrollbar"
            pageClassName="rounded-md border border-black hover:bg-blue-500 hover:text-white transition duration-300"
            pageLinkClassName="w-full h-full px-2 py-1 text-xs sm:text-sm flex items-center justify-center cursor-pointer"
            activeClassName="bg-blue-500 text-white border-blue-600"
            previousClassName="px-2 py-1 text-xs sm:text-sm border border-gray-200 rounded-md bg-gray-100 hover:bg-blue-500 hover:text-white transition duration-300 cursor-pointer"
            nextClassName="px-2 py-1 text-xs sm:text-sm border border-gray-200 rounded-md bg-gray-100 hover:bg-blue-500 hover:text-white transition duration-300 cursor-pointer"
            breakClassName="px-2 py-1 text-gray-500"
            disabledClassName="opacity-50 cursor-not-allowed"
            forcePage={currentPage}
          />
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default AllProductData;
